import React from 'react';
import { Button } from '@dotcom/crown-ui';
import { ActionButtonProps } from '../quantity-change-dialog-types';

export const ActionButton = ({ click, label }: ActionButtonProps): React.ReactElement => {
  return (
    <Button onClick={click} variant="primary" testId="action-button">
      {label}
    </Button>
  );
};
